module.exports = __webpack_public_path__ + "img/MotelOne_Zuerich_MotelOne_5.jpg";